module.exports = __webpack_public_path__ + "static/gans-468c3d8dcc2f46f48c89607854160f6a.png";